/** Product scope stored on feature pset `props.featureFor` (admin + clients). */
export type FeatureForProduct = 'all' | 'tcweb' | 'tcm' | 'tcd';

export const FEATURE_FOR_PRODUCT_VALUES: readonly FeatureForProduct[] = [
  'all',
  'tcweb',
  'tcm',
  'tcd',
] as const;

/**
 * Feature configuration interface
 */
export interface IFeatureConfig {
  /** Feature identifier (e.g., "mobile-mapping-v2") */
  featureId: string;
  /** PSet link (e.g., "frn:connect:feature:mobile-mapping-v2") */
  link: string;
  /** Library ID (e.g., "tc-feature-lib-01") */
  libId: string;
  /** Definition ID (e.g., "tc-feature-def-01") */
  defId: string;
}

/**
 * Feature flags map - maps featureId to boolean indicating if feature is accessible
 */
export interface IFeatureFlags {
  [featureId: string]: boolean;
}

/** Parsed feature pset `props` used for client-side checks after load. */
export interface IFeaturePsetProps {
  featureFor: FeatureForProduct;
  isOn: boolean;
  isScoped: boolean;
  accountIds?: string[];
  projectIds?: string[];
  groupIds?: string[];
  userIds?: string[];
}

/**
 * Current Connect context for `isScoped` evaluation (project sidebar, routes, etc.).
 * Omitting a field skips that dimension only when the pset has no list for it.
 *
 * `userIds` on the pset are not matched here; access is enforced by pset policy at read time.
 */
export interface IFeatureEvaluationContext {
  accountId?: string;
  projectId?: string;
  /** User's group IDs in the current project (for intersection with pset `groupIds`). */
  groupIds?: readonly string[];
}

/**
 * Loader abstraction for fetching PSet data.
 * Implementations can use CDMData, fetch, or other data sources.
 */
export interface IFeaturePsetLoader {
  loadOnePset(link: string, libId: string, defId: string): Promise<unknown>;
}

/**
 * Options for configuring FeatureHelper
 */
export interface FeatureHelperOptions {
  loader: IFeaturePsetLoader;
  features: IFeatureConfig[];
}
